<template>
  <div class="final-card-container">
    <div class="tarjeta-render">
      <img
        v-if="processedImageUrl"
        ref="imagenFondo"
        :src="processedImageUrl"
        class="foto-fondo"
        alt="Foto generada"
        @load="imagenCargada = true"
      />


      
      <img class="overlay-frame" src="@/assets/tarjeta_en_banco.png" alt="Marco decorativo" />
      <div class="tarjeta-preview">
        <div class="info-izquierda">
          <div class="nombre">{{ nombre }}</div>
          <div class="apellido">{{ apellido }}</div>
          <div class="numero">{{ numero }}</div>
        </div>
        <div class="info-derecha">
          <div class="posicion">{{ posicion }}</div>
          <div class="barra">
            <label>Velocidad</label>
            <div class="barra-externa">
              <div class="barra-interna" :style="{ width: `${velocidad * 10}%` }"></div>
            </div>

          </div>
          <div class="barra">
            <label>Precisión</label>
              <div class="barra-externa">
                <div class="barra-interna" :style="{ width: `${precision * 10}%` }"></div>
              </div>

          </div>
          <div class="barra">
            <label>Resistencia</label>
              <div class="barra-externa">
                <div class="barra-interna" :style="{ width: `${resistencia * 10}%` }"></div>
              </div>

          </div>
        </div>
      </div>

    </div>

    <div class="acciones">
      <button class="imprimir" @click="imprimir">🖨️ Imprime</button>
      <button class="imprimir" @click="descargarOriginal">⬇️ Descargar Img Orig</button>
      <div class="qr-section">
        <qrcode-vue :value="`https://hpinfo.online/check-result/${tokenFinal}`" :size="260" level="H" />
      </div>
    </div>
    <button class="btn-finalizar" @click="finalizar">Finalizar</button>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'

import QrcodeVue from 'qrcode.vue'
import tarjetaBase from '@/assets/tarjeta_en_banco.png'
import html2canvas from 'html2canvas'
// const datos = ref({})
const processedImageName = ref('')

const nombre = ref('')
const apellido = ref('')
const numero = ref('')
const posicion = ref('')
const velocidad = ref(5)
const precision = ref(5)
const resistencia = ref(5)

const imagenFondo = ref(null)
const imagenCargada = ref(false)

const store = useStore()
const tokenFinal = ref(store.state.tokens.tokenFinal || '')


const processedImageUrl = ref(tarjetaBase) // fallback

onMounted(() => {
  const data = JSON.parse(localStorage.getItem('datosTarjeta')) || {}
  processedImageName.value = localStorage.getItem('processedImageName') || ''
  tokenFinal.value = store.state.tokens.tokenFinal || ''


  nombre.value = data.nombre || ''
  apellido.value = data.apellido || ''
  numero.value = data.numero || ''
  posicion.value = data.posicion || ''
  velocidad.value = data.velocidad || 5
  precision.value = data.precision || 5
  resistencia.value = data.resistencia || 5

  if (processedImageName.value) {
    processedImageUrl.value = `/img/imagenes_modificadas/${processedImageName.value}`
  }

  setTimeout(() => {
    enviarImagenCompilada()
  }, 800)
})

const descargarOriginal = () => {
  if (!processedImageName.value) {
    alert('No se encontró la imagen original.');
    return;
  }

  const link = document.createElement('a')
  link.href = `/img/imagenes_modificadas/${processedImageName.value}`
  link.download = processedImageName.value
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}


const imprimir = async () => {
  if (!imagenCargada.value) {
    alert('Espera a que cargue la imagen')
    return
  }

  await nextTick() // asegura que todo esté montado

  const tarjeta = document.querySelector('.tarjeta-render')
  if (!tarjeta) return

  const canvas = await html2canvas(tarjeta, {
    scale: 2,
    useCORS: true,
    backgroundColor: null
  })

  const link = document.createElement('a')
  link.href = canvas.toDataURL('image/png')
  link.download = 'tarjeta_final.png'
  link.click()
} 

const finalizar = () => window.location.href = '/gracias' // O ruta deseada

const enviarImagenCompilada = async () => {
  await nextTick()
  const tarjeta = document.querySelector('.tarjeta-render')
  if (!tarjeta) return

  const canvas = await html2canvas(tarjeta, {
    scale: 2,
    useCORS: true,
    backgroundColor: null,
  })

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'))
  const formData = new FormData()
  formData.append('imagen', blob, 'tarjeta_final.png')
  formData.append('clave_final', tokenFinal.value)
  formData.append('tipo', 'imagen')
  formData.append('token_premio', 'NANANA')
  formData.append('autorizado', '1')

  try {
    const response = await fetch('https://hpinfo.online/api/guardar-imagen-clave', {
      method: 'POST',
      body: formData,
    })

    const data = await response.json()
    console.log('Imagen enviada:', data)
  } catch (err) {
    console.error('Error al enviar imagen:', err)
  }
}


</script>

<style scoped lang="scss">
.overlay-frame {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none; 
    z-index: 5;
  }

.final-card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #0095d9;
  min-height: 100vh;
  color: white;
  font-family: 'FormaDJRDisplay', sans-serif;
  padding: 2vh 4vw; 
  width: 100%;
  flex-direction: row;
  justify-content: space-evenly;
}

.tarjeta-render {
  position: relative;
  width: 477px;
  height: 716px;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.foto-fondo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.datos-superpuestos {
  position: absolute;
  top: 0;
  left: 0;
  padding: 1.5rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: #1a1a1a;
}

.nombre {
  font-size: 1.5rem;
  font-weight: 500;
}
.apellido {
  font-size: 2rem;
  line-height: 1;
  font-weight: bold;
}
.numero {
  font-size: 2.4rem;
}
.posicion {
  font-size: 1.2rem;
  margin-top: 0.5rem;
}

.barra {
  margin-top: 0.2rem;
}
.barra label {
  font-size: 0.9rem;
}
progress {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
}
progress::-webkit-progress-value {
  background: #3f51b5;
}
progress::-webkit-progress-bar {
  background: #eee;
}

.acciones {
  margin-top: 2rem;
  text-align: center;
}
.acciones button {
  margin: 1rem;
  padding: 0.6rem 1.5rem;
  font-size: 1rem;
  // background: white;
  border: none;
  color: #fff;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  letter-spacing: 2px;
  // color: #0095d9;
  // border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: #fff;
    color: #000;

  }
}
.qr-section {
  margin: 1rem auto;
  padding: 1rem;
  background: #fff;
}


.tarjeta-preview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  display: flex;
  justify-content: space-between;
  padding: 1rem 1.2rem;
  box-sizing: border-box;
  pointer-events: none;
  font-family: 'FormaDJRDisplay', sans-serif;
  color: #1a1a1a;
}

.info-izquierda {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  font-weight: bold;
  font-size: 1rem;
  text-align: left;

  .nombre {
    font-size: 1.5rem;
    font-weight: 500;
    min-height: 36px;
  }

  .apellido {
    font-size: 2rem;
    min-height: 48px;
  }
  
  .numero {
    font-size: 2.4rem;
    line-height: 1.2;
    min-height: 46px;
  }
}

.info-derecha {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  font-weight: bold;
  text-align: right;

  .posicion {
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
  }

  .barra {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 0.8rem;
    // margin-bottom: 0.3rem;

    label {
      margin-bottom: 0.2rem;
    }

    progress {
      width: 120px;
      height: 8px;
      border-radius: 4px;
      overflow: hidden;
      background: #eee;

      &::-webkit-progress-bar {
        background-color: #eee;
        border-radius: 4px;
      }

      &::-webkit-progress-value {
        background-color: #3f51b5;
        border-radius: 4px;
      }

      &::-moz-progress-bar {
        background-color: #3f51b5;
      }
    }
  }
}

.barra-externa {
  width: 120px;
  height: 8px;
  background-color: #eee;
  border-radius: 4px;
  overflow: hidden;
}

.barra-interna {
  height: 100%;
  background-color: #3f51b5;
  transition: width 0.3s ease;
}
.imprimir {

}
.btn-finalizar {
  position: absolute;
  bottom: 5vw;
  right: 5vw;
  letter-spacing: 2px;
  font-size: 2em;
  display: block;
  padding: 0.3rem 1rem;
  transition: all 0.2s;
  &:hover{ 
    background: #fff;
    color: #000;
  }
}

.acciones button:nth-child(2) {
  background-color: #444;
  color: #fff;

  &:hover {
    background-color: #fff;
    color: #444;
  }
}

</style>
